import React, { useMemo, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormikContext } from "formik";
import {
  SectionContent,
  SelectControl,
  ButtonPrimary,
  Loading,
} from "../../../../components";
import { envs, links } from "../../../../config";
import { ManuaisAssistenciasForm } from "../../../../forms";
import { useStaticJsonRequest } from "../../../../hooks";
import {
  distinctArray,
  getMonths,
  mapToOptions,
  parseISO,
} from "../../../../utils";

import * as S from "./BaixarAssistencias.Style";

const Formulario = ({ mapeamento }) => {
  const { values, submitForm, setFieldValue } = useContext(FormikContext);

  const productsOptions = useMemo(() => {
    const produtos = distinctArray(mapeamento.map((item) => item.produto));
    return mapToOptions(produtos);
  }, [mapeamento]);

  const anoOptions = useMemo(() => {
    const anos = distinctArray(
      mapeamento
        .filter((item) => item.produto === values.produto)
        .map((item) => parseISO(item.vigencia).getFullYear())
    );
    return mapToOptions(anos);
  }, [mapeamento, values.produto]);

  const versaoOptions = useMemo(() => {
    const versoes = distinctArray(
      mapeamento
        .filter((item) => item.produto === values.produto)
        .map((item) => parseISO(item.vigencia))
    )
      .filter(
        (vigencia) => vigencia.getFullYear() === Number.parseInt(values.ano, 10)
      )
      .map((vigencia) => ({
        value: vigencia.getMonth(),
        label: `${getMonths()[vigencia.getMonth()]} - ${values.ano}`,
      }));

    return mapToOptions(versoes);
  }, [mapeamento, values.ano, values.produto]);

  useEffect(() => {
    const { produto, ano, versao } = values;

    const { href } = {
      ...mapeamento.find((item) => {
        const vigencia = parseISO(item.vigencia);

        return (
          item.produto === produto &&
          vigencia.getFullYear() === Number.parseInt(ano, 10) &&
          vigencia.getMonth() === Number.parseInt(versao, 10)
        );
      }),
    };

    setFieldValue("manualAssistenciaLink", href);

    if (href) {
      submitForm();
    }
  }, [mapeamento, setFieldValue, submitForm, values]);

  return (
    <S.FormContent>
      <SelectControl
        options={productsOptions}
        name="produto"
        label="Produto"
        placeholder="Selecione"
      />
      <SelectControl
        options={anoOptions}
        name="ano"
        label="Ano"
        placeholder="Selecione"
      />
      <SelectControl
        options={versaoOptions}
        name="versao"
        label="Versão"
        placeholder="Selecione"
      />
    </S.FormContent>
  );
};

Formulario.propTypes = {
  mapeamento: PropTypes.arrayOf(
    PropTypes.shape({
      produto: PropTypes.string.isRequired,
      vigencia: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const BaixarAssistencias = () => {
  const { data: mapeamento, loading } = useStaticJsonRequest(
    links.residencial.mapaDeManuaisAssistencias
  );

  const [{ manualAssistenciaLink }, setManualAssistencia] = useState({
    manualAssistenciaLink: "",
  });

  return (
    <Loading loading={loading}>
      <S.Container as={SectionContent}>
        <S.FormContainer>
          <ManuaisAssistenciasForm
            form={Formulario}
            mapeamento={mapeamento || []}
            onSelectManual={setManualAssistencia}
          />
        </S.FormContainer>
        <S.ButtonCondicoesGerais
          as={ButtonPrimary}
          href={`${envs.hostStaticCdn}${manualAssistenciaLink}`}
          target="_blank"
          label="Baixar manual de assistência"
          disabled={!manualAssistenciaLink}
        />
      </S.Container>
    </Loading>
  );
};

BaixarAssistencias.propTypes = {};

export default BaixarAssistencias;
